import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  constructor(private http: HttpClient) {}

  getSettings(): Observable<any> {
    return this.http.get(`/admin/settings/manage/`);
  }

  updateSettings(data): Observable<any> {
    return this.http.post(`/admin/settings/manage/`, data);
  }

  getBKTicketsTypes(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`/admin/hd_ticket_types/esas`).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getHDTicketsTypes(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`/admin/hd_ticket_types/hd`).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getTicketsTypes(): Promise<any> {
    return Promise.all([this.getBKTicketsTypes(), this.getHDTicketsTypes()]);
  }

  saveTicketsTypes(data): Observable<any> {
    return this.http.post(`/admin/hd_ticket_types`, data);
  }
}
